import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3af991c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = { class: "text-h6" }
const _hoisted_4 = {
  class: "text-subtitle2",
  style: {"margin-left":"2rem"}
}
const _hoisted_5 = {
  style: {"max-width":"30vw"},
  class: "container--span__file_scan"
}
const _hoisted_6 = {
  key: 0,
  class: "cursor-pointer"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  class: "q-pa-md",
  style: {"min-width":"15vw"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "share", -1))
const _hoisted_10 = {
  class: "row",
  style: {"display":"flex","max-width":"100px","width":"100%","margin-left":"5px"}
}
const _hoisted_11 = { style: {"text-align":"right"} }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderTimeAccountsMarca = _resolveComponent("HeaderTimeAccountsMarca")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.person.nume_prenume), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.person.organization_unit_descriere) + " / " + _toDisplayString(_ctx.person.job_title), 1)
    ]),
    _createVNode(_component_HeaderTimeAccountsMarca, {
      marca: _ctx.marca,
      year: _ctx.year,
      ref: "childHeaderMyTimesRequests"
    }, null, 8, ["marca", "year"]),
    _createVNode(_component_q_table, {
      dense: "",
      "rows-per-page-options": [0],
      rows: _ctx.tableDataConcedii,
      columns: _ctx.columns,
      "visible-columns": _ctx.visibleColumns,
      "row-key": "appid",
      filter: _ctx.filterConcedii,
      loading: _ctx.loadingData,
      pagination: _ctx.myPagination
    }, {
      top: _withCtx(() => [
        _createVNode(_component_q_space),
        _createVNode(_component_q_input, {
          dense: "",
          debounce: "300",
          color: "primary",
          modelValue: _ctx.filterConcedii,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterConcedii) = $event))
        }, {
          append: _withCtx(() => [
            _createVNode(_component_q_icon, { name: "search" })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      body: _withCtx((props) => [
        _createVNode(_component_q_tr, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_td, {
              key: "appid",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(props.row.appid), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "tip_concediu",
              props: props,
              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.tip_concediu), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "nr_working_days",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString((props.row.nr_days_recalculated != 0 && (props.row.flag & 8) != 0) ? props.row.nr_working_days + " / " + props.row.nr_days_recalculated : props.row.nr_working_days), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "start_date",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.start_date), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "end_date",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.end_date), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "denumire_stare",
              props: props,
              class: _normalizeClass(_ctx.displayStatusColor(props.row.stare))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.denumire_stare), 1)
              ]),
              _: 2
            }, 1032, ["props", "class"]),
            _createVNode(_component_q_td, {
              key: "track_date_status",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.track_date_status), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "observatie",
              props: props,
              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.observatie), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "nr_recall_days",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.nr_recall_days), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "recall_date",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (props.row.recall_date.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (props.row.recall_date.length == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.displayDataRO(props.row.recall_date[0])), 1)
                            ]))
                          : (_openBlock(), _createBlock(_component_q_badge, {
                              key: 1,
                              color: "blue",
                              transparent: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.recall_date.length) + " ", 1),
                                _createVNode(_component_q_menu, {
                                  fit: "",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.recall_date, (recalldate) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: recalldate,
                                          class: "span__repartizare"
                                        }, [
                                          _hoisted_9,
                                          _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.displayDataRO(recalldate)), 1)
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12))
                ])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"])
  ]))
}